import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Channel from "./pages/Channel";
import Album from "./pages/Album";
import Total from "./pages/Total";
import Settings from "./pages/Settings";
import EditProfile from "./pages/EditProfile";
import ChangePassword from "./pages/ChangePassword";
import Revenue from "./pages/Revenue";
import Signup from "./pages/Signup";
import VideoRightsManager from "./pages/video/VideoRightsManager";
import VideoWhitelist from "./pages/video/VideoWhitelist";
import TotalForCopyrights from "./pages/TotalForCopyrights";
import PendingVerification from "./pages/PendingVerification";
import TermsOfService from "./pages/TermsOfService";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ResetPassword from "./pages/ResetPassword";
import WatchaShorts from "./pages/WatchaShorts";
import { createGlobalStyle } from "styled-components";
import styled from "styled-components";
import { ChakraProvider } from "@chakra-ui/react";
import { UserProvider } from "./contexts/UserContext";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminUsers from "./pages/admin/AdminUsers";
import AdminChannels from "./pages/admin/AdminChannels";
import AdminMusic from "./pages/admin/AdminMusic";
import AdminVideos from "./pages/admin/AdminVideos";
import AdminVideoApplications from "./pages/admin/AdminVideoApplications";
import AdminSupport from "./pages/admin/AdminSupport";
import AdminVideoRevenue from "./pages/admin/AdminVideoRevenue";
import AdminSettlement from "./pages/admin/AdminSettlement";
import AdminSettlementRequest from "./pages/admin/AdminSettlementRequest";
import AdminShortsMusicRevenue from "./pages/admin/AdminShortsMusicRevenue";
import AdminVideoSettlement from "./pages/admin/AdminVideoSettlement";
import RedirectToLaeebly from "./components/RedirectToLaeebly";

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
      Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  }
`;

const AppContainer = styled.div`
  min-height: 100vh;
`;

export default function App() {
  return (
    <ChakraProvider>
      <GlobalStyle />
      <AppContainer>
        <Router>
          <UserProvider>
            <Routes>
              {/* 어드민 경로만 허용 */}
              <Route path="/admin/*" element={
                <Routes>
                  <Route path="/" element={<AdminLayout />}>
                    <Route index element={<Navigate to="dashboard" replace />} />
                    <Route path="dashboard" element={<AdminDashboard />} />
                    <Route path="users" element={<AdminUsers />} />
                    <Route path="channels" element={<AdminChannels />} />
                    <Route path="music" element={<AdminMusic />} />
                    <Route path="videos" element={<AdminVideos />} />
                    <Route
                      path="video-applications"
                      element={<AdminVideoApplications />}
                    />
                    <Route path="video-revenue" element={<AdminVideoRevenue />} />
                    <Route path="support" element={<AdminSupport />} />
                    <Route path="settlement" element={<AdminSettlement />} />
                    <Route path="settlement-request" element={<AdminSettlementRequest />} />
                    <Route path="shorts-music-revenue" element={<AdminShortsMusicRevenue />} />
                    <Route path="video-settlement" element={<AdminVideoSettlement />} />
                  </Route>
                </Routes>
              } />
              
              {/* 로그인 페이지 허용 */}
              <Route path="/login" element={<Login />} />
              
              {/* 어드민과 로그인 경로를 제외한 모든 경로는 laeebly.io로 리다이렉트 */}
              <Route path="*" element={<RedirectToLaeebly />} />
            </Routes>
          </UserProvider>
        </Router>
      </AppContainer>
    </ChakraProvider>
  );
}